import { GetMembershipDetails, IGetMembershipDetailsRequest } from '../contracts';
import axios, { AxiosError } from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import StatusCode from 'status-code-enum';
import { Pages } from '../../utils/constants';

export const GetMembershipDetailsApi =
  (endpoint: string): GetMembershipDetails =>
  async (request) => {
    try {
      const campaignCode = request?.campaignCode;

      let url = endpoint;
      if (campaignCode) {
        url += `?campaignCode=${campaignCode}`;
      }

      const config = createAxiosConfig(url);

      const response = await axios.get(url, config);

      LogCannon.blast('GetMembershipDetailsApi success');
      return Promise.resolve(response.data.data);
    } catch (e: any | AxiosError) {
      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('GetMembershipDetailsApi error', errorResponse);

      return Promise.reject({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'GetMembershipDetailsApi failed',
          ...errorResponse,
        },
      });
    }
  };
